import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';
import { Subject, forkJoin, map, of, tap, } from 'rxjs';
import { AlertService } from "../../../../services/alert.service";
import { IpPublicService } from 'src/app/services/ip-public.service';
import { ModalService } from 'src/app/services/modal.service';
import { TreeNode } from "primeng/api";
import { UnidadesSiipneService } from 'src/app/services/unidades-siipne.service';
import { ComunService } from '../../services/comun.service';
import { SubsistemaService } from '../../services/subsistema.service';
import { AmbienteService } from 'src/app/modulos/catalogos-admin/services/ambiente.service';
import { ProcesoService } from 'src/app/modulos/elementos-plan/services/proceso.service';
import { ConstantsCatalogosIdService } from 'src/app/services/constants-catalogos-id.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { ProyectoService } from 'src/app/modulos/elementos-plan/services/proyecto.service';
import { ObjetivoService } from 'src/app/modulos/elementos-plan/services/objetivo.service';
import { AtribucionService } from 'src/app/modulos/elementos-plan/services/atribucion.service';
import { AreaService } from 'src/app/modulos/catalogos-admin/services/area.service';
import { EquipoGerencialService } from '../../services/equipo.gerencial.service';
import { AmbRolUsuarioService } from 'src/app/modulos/admin/services/amb.rol.usuario.service';


@Component({
  selector: 'app-ambientes',
  templateUrl: './ambiente.component.html'
})
export class AmbienteComponent implements OnInit, OnDestroy {

  breadCrumbItems = [{ label: 'Administración Sistema' }, { label: 'Administración' }, { label: 'Ambientes', active: true }];

  formAmbiente: FormGroup;
  ipAddress!: string;
  submitted: boolean = false;
  public buffer: any;
  public currentAmbiente: any;
  public nombreUnidad!: any;
  public idSprAmbiente!: number;
  ambientes: any[] = [];
  subsistemas: any[] = [];
  niveles: any[] = [];
  selectItems: any[] = [];
  idSprAmbienteEliminar: number = 0;
  spr_idSprAmbiente: number = 0;
  colorDisabledRow: string ='';
  nombreUnidadPadre: any[] = [];

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  isDtInitialized: boolean = false;

  dataUnidadesTree: TreeNode[];
  selectedFile: TreeNode;

  dataAmbientesTree: TreeNode[];
  selectedFileAmbientes: TreeNode;

  currentUser!: any;

  showConfirm: boolean = false;
  idTipoNivel = ConstantsCatalogosIdService.ID_COMUNES_NIVELES;

  readonly constant = ConstantsCatalogosIdService;

  constructor(
    private fb: FormBuilder,
    private ambienteService: AmbienteService,
    private unidadesSiipneService: UnidadesSiipneService,
    private comunService: ComunService,
    private subsistemaService: SubsistemaService,
    private alertService: AlertService,
    private ip: IpPublicService,
    public modal: ModalService,
    private procesoService: ProcesoService,
    private proyectoService: ProyectoService,
    private objetivoService: ObjetivoService,
    private atribucionService: AtribucionService,
    private areaService: AreaService,
    private equipoGerencialService: EquipoGerencialService,
    private ambRolUsuarioService: AmbRolUsuarioService,
    private store: Store<AppState>,
  ) {
    this.buffer = localStorage.getItem('currentUser');
    this.currentAmbiente = JSON.parse(this.buffer);
    this.nombreUnidad = this.currentAmbiente.nombreUnidad;
    this.selectItems = [
      { value: '', label: 'Seleccione' },
      { value: 1, label: 'Activo' },
      { value: 2, label: 'Inactivo' },
    ];
  }

  get ambFrm() {
    return this.formAmbiente.controls;
  }

  initForm() {
    this.formAmbiente = this.fb.group({
      idSprAmbiente: [],
      spr_idSprAmbiente: [],
      idDgpUnidad: ['', [Validators.required]],
      idSprNivel: ['', [Validators.required]],
      idSprSubsistema: [''],
      nombreUnidad: ['', [Validators.required]],
      nombreCorto: ['', [Validators.required]],
      fechaInicio: ['', [Validators.required]],
      fechaFin: ['', [Validators.required]],
      estado: ['', [Validators.required]],
    });
    this.formAmbiente.patchValue({
      estado: this.selectItems[0].value,
    });
  }

  setDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      destroy: true,
      language: {
       // url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
      },
    };
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  reDrawDataTable() {
    if (this.isDtInitialized) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else {
      this.isDtInitialized = true;
      this.dtTrigger.next(null);
    }
  }

  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  ngOnInit(): void {
    this.getIpPublic();
    this.store.select("globalApp").subscribe((response) => {// redux
      this.idSprAmbiente = response.ambienteSeleccionado.idSprAmbiente;
    });
    this.store.select("usuarioApp").subscribe((response) => {
      this.currentUser = response.currentUser;
    });
    this.initApp();
  }
  
  
  initApp() {
    this.spr_idSprAmbiente = 0;
    this.getTreeUnidadesSiipne();
    this.getTreeAmbientes();
    this.listElementosComun();
    this.setDataTable();
    this.initForm
    this.initForm();
  }


  listElementosComun() {
    let condicionRol ='?estado=1&admin=2';
    if(ConstantsCatalogosIdService.ADMINISTRADOR == 1 || ConstantsCatalogosIdService.SUBADMINISTRADOR == 2){
      condicionRol ='';
    } 

    forkJoin([
      
      this.comunService.list(`?spr_idSprComun=${this.idTipoNivel}`),
      this.subsistemaService.list(),
      this.ambienteService.list(condicionRol)
    ]).pipe(
      map(([niveles, subsistemas, dataAmbinetes]) => {
        this.niveles = niveles;
        this.subsistemas = subsistemas;
        this.ambientes = dataAmbinetes;
        this.reDrawDataTable();
      })).subscribe({
      })
  }

  getTreeUnidadesSiipne() {
    this.unidadesSiipneService.listParents().subscribe((resp: TreeNode[] | any) => {
      console.log("Unidades",resp)
      if (!resp.error) {
        this.dataUnidadesTree = resp;
      } else {
        this.dataUnidadesTree = [];
      }
      this.dataUnidadesTree.forEach(node => {
        this.unidadesSiipneService.listChilds(node.data).subscribe((respChild: TreeNode[] | any) => {
          if (!respChild.error) {
            node.children = respChild;
          }
        });
      });
    });
  }

  getTreeAmbientes() {
    this.ambienteService.listParents().subscribe((resp: TreeNode[] | any) => {
      if (!resp.error) {
        this.dataAmbientesTree = resp;
      } else {
        this.dataAmbientesTree = [];
      }
      this.dataAmbientesTree.forEach(node => {
        this.ambienteService.listChilds(node.data).subscribe((respChild: TreeNode[] | any) => {
          if (!respChild.error) {
            node.children = respChild;
          }
        });
      });
    });
  }


  edit(obj: any) {
    if(obj.spr_idSprAmbiente != null){
    this.ambienteService.list(obj.spr_idSprAmbiente).subscribe(
      resp=>{
        this.nombreUnidadPadre = resp.nombreUnidad
      }
    )
    }else{
      this.nombreUnidadPadre = null;
    }
    this.collapseTreeAmbientes2(obj.idSprAmbiente),

    
    this.openModal();
    this.spr_idSprAmbiente = obj.spr_idSprAmbiente,
    this.formAmbiente.patchValue({
      idSprAmbiente: obj.idSprAmbiente,
      spr_idSprAmbiente: obj.spr_idSprAmbiente,
      idDgpUnidad: obj.idDgpUnidad,
      idSprNivel: obj.idSprNivel,
      idSprSubsistema: obj.idSprSubsistema,
      nombreUnidad: obj.nombreUnidad,
      nombreCorto: obj.nombreCorto,
      fechaInicio: obj.fechaInicio,
      fechaFin: obj.fechaFin,
      estado: obj.estado
    });
  }

  delete(id: number) {
    this.idSprAmbienteEliminar = id;
    this.modal.open('del');
  }

  verifyProceso() {
    return this.procesoService.list(`?idSprAmbiente=${this.idSprAmbienteEliminar}&delLog=N`).toPromise();
  }

  verifyProyecto() {
    return this.proyectoService.list(`?idSprAmbiente=${this.idSprAmbienteEliminar}&delLog=N`).toPromise();
  }

  verifyEquipoGerencial() {
    return this.equipoGerencialService.list(`?idSprAmbiente=${this.idSprAmbienteEliminar}&delLog=N`).toPromise();
  }

  verifyObjetivo() {
    return this.objetivoService.list(`?idSprAmbiente=${this.idSprAmbienteEliminar}&delLog=N`).toPromise();
  }

  verifyAmbRolUsuario() {
    return this.ambRolUsuarioService.list(`?idSprAmbiente=${this.idSprAmbienteEliminar}&delLog=N`).toPromise();
  }
  verifyAtribucion() {
    return this.atribucionService.list(`?idSprAmbiente=${this.idSprAmbienteEliminar}&delLog=N`).toPromise();
  }

  verifyArea() {
    return this.areaService.list(`?idSprAmbiente=${this.idSprAmbienteEliminar}&delLog=N`).toPromise();
  }


  async confirmDelete() {
    let confirmDelete = true;
    let dataVerifyRelacion: any = [];
    dataVerifyRelacion = await this.verifyProceso();
    (dataVerifyRelacion.length > 0) ? confirmDelete = false : "";
    dataVerifyRelacion = await this.verifyProyecto();
    (dataVerifyRelacion.length > 0) ? confirmDelete = false : "";
    dataVerifyRelacion = await this.verifyEquipoGerencial();
    (dataVerifyRelacion.length > 0) ? confirmDelete = false : "";
    dataVerifyRelacion = await this.verifyObjetivo();
    (dataVerifyRelacion.length > 0) ? confirmDelete = false : "";
    dataVerifyRelacion = await this.verifyAmbRolUsuario();
    (dataVerifyRelacion.length > 0) ? confirmDelete = false : "";
    dataVerifyRelacion = await this.verifyAtribucion();
    (dataVerifyRelacion.length > 0) ? confirmDelete = false : "";
    dataVerifyRelacion = await this.verifyArea();
    (dataVerifyRelacion.length > 0) ? confirmDelete = false : "";
    if (confirmDelete) {
      this.ambienteService.update({
        "idSprAmbiente": this.idSprAmbienteEliminar,
        "usuario": this.currentUser.idSprUsuario,
        "delLog": "S",
        "ip": this.ipAddress
      }).subscribe(resp => {
        this.initApp();
        //REMOVER CON FILTER
        //this.ambientes = this.ambientes.filter((ambiente) => ambiente.idSprAmbiente !== resp.idSprAmbiente)
        this.alertService.deleteOk();
        this.modal.close();
      }, (err) => {
        this.alertService.deleteError();
        this.modal.close();
      });
    }
    else {
      this.alertService.EliminarRegistro();
    }
  }

  showEliminar(id: number) {
    this.showConfirm = true;
    this.idSprAmbienteEliminar = id;
  }

  onSubmit() {
   let existeAmbiente:Boolean = false;
    this.submitted = true;
    this.formAmbiente.value.usuario = this.currentAmbiente.idSprUsuario;
    this.formAmbiente.value.ip = this.ipAddress;
    this.formAmbiente.value.admin = 2;
    this.formAmbiente.value.spr_idSprAmbiente = this.spr_idSprAmbiente;
    if (this.formAmbiente.invalid) {
      return;
    }
    if (this.formAmbiente.value.fechaInicio > this.formAmbiente.value.fechaFin) {
      this.alertService.fechaError();
      return;
    }
    if (this.formAmbiente.value.idSprAmbiente === null || this.formAmbiente.value.idSprAmbiente === "") {
          this.ambienteService.list(`?idDgpUnidad=${this.formAmbiente.value.idDgpUnidad}&estado=1`).subscribe({
            next:(resp)=>{
              let dataResponse = resp      
              if (dataResponse.length > 0) {
                existeAmbiente = true;
                this.alertService.warning("¡Atención!", "Este ambiente ya existe.");
              }else{
                if(!existeAmbiente){
                this.ambienteService.create(this.formAmbiente.value).subscribe(resp => {
                  this.modal.close();
                  this.initApp();

                  this.alertService.createOk();
                }, (err) => {
                  this.alertService.createError();
                });
              }
              }
            }
          })       
    } else {
      this.ambienteService.update(this.formAmbiente.value).subscribe(resp => {
        this.modal.close();
        this.initApp();
        this.alertService.updateOk();
      }, (err) => {
        this.alertService.updateError();
      });
    }
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next(this.dtOptions);
    });
  }



  private collapseTreeUnidades() {
    if (this.dataUnidadesTree) {
      this.dataUnidadesTree.forEach((node) => {
        this.expandRecursiveUnidades(node, false);
      })
    }
  }

  private expandRecursiveUnidades(node: TreeNode, isExpand: boolean) {
    node.expanded = isExpand;
    if (node.children) {
      node.children.forEach((childNode) => {
        this.expandRecursiveUnidades(childNode, isExpand);
      })
    }
  }

  private collapseTreeAmbientes() {
    if (this.dataAmbientesTree) {
      this.dataAmbientesTree.forEach((node) => {
        this.expandRecursiveAmbientes(node, false);
      })
    }
  }

  private expandRecursiveAmbientes(node: TreeNode, isExpand: boolean) {
    node.expanded = isExpand;
    if (node.children) {
      node.children.forEach((childNode) => {
        this.expandRecursiveAmbientes(childNode, isExpand);
      })
    }
  }

  private collapseTreeAmbientes2(id:number = 0) {
    if (this.dataAmbientesTree) {
      this.dataAmbientesTree.forEach((node) => {
        if(node.data == id  ){
          this.expandRecursiveAmbientes2(node, false);     
        }else{
          this.expandRecursiveAmbientes2(node, true);
        }

      })
    }
  }

  private expandRecursiveAmbientes2(node: TreeNode, isExpand: boolean) {
    node.expanded = isExpand;
    if (node.children) {
      node.children.forEach((childNode) => {
        this.expandRecursiveAmbientes2(childNode, isExpand);
      })
    }
  }


  nodeSelect(evt) {
    this.formAmbiente.patchValue({
      idDgpUnidad: evt.node.data,
      nombreUnidad: evt.node.label
    });
  }
  nodeSelectAmbientes(evt) {
    this.nombreUnidadPadre = evt.node.label
    this.spr_idSprAmbiente = evt.node.data;
       // this.formAmbiente.patchValue({
    //   spr_idSprAmbiente: evt.node.data,
    //   //nombreUnidad: evt.node.label
    // });
  }

  nodeExpandAmbientes(event) {
    if (event.node) {
      this.ambienteService.listChilds(event.node.data).subscribe(resp => {
        event.node.children = resp;
      });
    }
  }
  
  nodeExpand(event) {
    if (event.node) {
      this.unidadesSiipneService.listChilds(event.node.data).subscribe(resp => {
        event.node.children = resp;
      });
    }
  }

  mensajeAmbientePadre(e:any){
if(this.spr_idSprAmbiente == 0 ){
  this.alertService.warning("¡Atención!", "Usted va crear un ambiente padre?, caso contrario debe seleccionar el ambiente dependiente, del arbolo de ambientes!");
}
}
  openModal() {
    //this.spr_idSprAmbiente = 0;
    this.submitted = false;
    this.selectedFile = null;
    this.selectedFileAmbientes = null;
    this.formAmbiente.reset();
    this.modal.open('new');
  }
  closeModal() {
    this.nombreUnidadPadre=[]
    this.modal.close()
    this.initApp();
    this.formAmbiente.reset();
    
  }
}